import { $window } from '../../helpers/globalVars';
import { customDots } from '../../helpers/slick';

const handler = ( $ ) => {
	const $cards = $( '.cards-3-across__cards' );

	if ( $cards.length == 0 ) {
		return;
	}

	const slickInit = () => {
		const windowWidth = $window.width();

		$cards.each( function ( _, el ) {
			const $_cards = $( el ),
				$cardsSlickInit = $_cards.filter( '.slick-initialized' ),
				$card = $( '.cards-3-across__card', $_cards );

			const cardLength = $card.length;

			if ( cardLength > 2 ) {
				if ( $cardsSlickInit.length != 0 ) {
					$cardsSlickInit.slick( 'unslick' );
				}

				if ( windowWidth <= 768 ) {
					$_cards.slick( {
						infinite: false,
						arrows: false,
						dots: true,
						variableWidth: true,
						touchThreshold: 10,
						speed: 150,
					} );
				} else if ( windowWidth < 950 ) {
					$_cards.slick( {
						infinite: false,
						arrows: false,
						dots: true,
						variableWidth: true,
						touchThreshold: 10,
						speed: 150,
						slidesToShow: 1,
						centerMode: true,
					} );
				}
			}
		} );
	};

	$cards.on( 'init', customDots );
	$window.on( 'resize', slickInit ).trigger( 'resize' );
};

( ( $ ) => {
	$( handler );
} )( jQuery );
